import { useEffect, useState } from 'react'
import Notiflix, { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { ViewPanacoClientDataModalContent } from '../modalContent/viewPanacoClientDataContent'
import Modal from '../reusable/modal'
import api from '../../helpers/apiRequester'
import { getLoginUrl } from '../../helpers/authConfig'
import styles from './styles.module.scss'
const PanacoSearch = () => {
    const [clientModalState, setClientModalState] = useState(false)
    const [searchResults, setSearchResults] = useState<any>()
    const [searchTerm, setSearchTerm] = useState('')
    useEffect(() => {
        if (searchResults != null) {
            setClientModalState(true)
        }
    }, [searchResults])
    const clientToggleModal = () => {
        setSearchResults(null)
        setClientModalState(false)
    }

    const searchClient = async () => {
        console.log('SEARCHING CLIENT', searchTerm)
        Loading.circle('Loading...')
        try {
            if (searchTerm.trim() == '') {
                Notiflix.Report.warning('No Search Term', 'Please enter a search term to search for a client.', 'Okay')
            }
            const apiResponse = await api({
                url: '/search-panaco-client',
                data: { term: searchTerm.trim() },
            })
            const data = apiResponse.data
            if (data.results.length > 0) {
                setSearchResults(data.results[0])
            } else {
                Notiflix.Report.warning('No Results Found', 'No results found for the search term.', 'Okay')
            }
            Loading.remove()
        } catch (error: any) {
            console.log(error)
            Loading.remove()
            if (error?.response.status == 401) {
                Report.failure('Session Timed Out', 'Please log in again to continue.', 'Okay', () => {
                    window.location.href = getLoginUrl()
                })
            } else {
                window.location.href = getLoginUrl()
            }
        }
    }

    return (
        <div className={styles.panacoSearchContainer}>
            <h3>Search Client</h3>
            <p>Search for a client by email address</p>

            <form
                className={styles.panacoSearchForm}
                style={{ margin: 0 }}
                onSubmit={(e) => {
                    e.preventDefault()
                    searchClient()
                }}
            >
                <input type="text" placeholder="Email Address" onChange={(e) => setSearchTerm(e.target.value)} />
                <button onClick={() => searchClient()}>Search</button>
            </form>

            {searchResults && (
                <Modal modalState={clientModalState} previewModalAction={clientToggleModal}>
                    <ViewPanacoClientDataModalContent clientData={searchResults} closeModal={clientToggleModal} />
                </Modal>
            )}
        </div>
    )
}

export default PanacoSearch
